import {
  isBaseQuestionAnswered,
  questionHasRemainingDisclosures,
} from "./baseQuestion";

import { BaseQuestionResource } from "../types/BaseQuestionResource";
import { CustomSections } from "../../../features/interview/types";
import { EdhConditionDisclosureResource } from "../types/EdhConditionDisclosureResource";
import { EdhPrimaryPhysicianResource } from "../types/EdhPrimaryPhysicianResource";
import { QuestionSectionResource } from "../types/QuestionSectionResource";

/**
 * Returns false if no visible questions in section.
 * Used in order to avoid empty sections in interview.
 * @param {QuestionSectionResource} section The section to check.
 * @return {boolean} True if section has visible questions, otherwise false.
 * */
export const sectionHasVisibleQuestions = (
  section: QuestionSectionResource,
) => {
  return (
    section.baseQuestions.filter((baseQuestion) => baseQuestion.visible)
      .length > 0 || section.code === CustomSections.PRIMARY_PHYSICIAN
  );
};

/**
 * Returns true if all questions in section are completed.
 * @param section A section of base questions.
 */
export const isSectionCompleted = (
  section: QuestionSectionResource,
  primaryPhysician: EdhPrimaryPhysicianResource[],
  embeddedDisclosures?: EdhConditionDisclosureResource[],
) => {
  if (section.code !== CustomSections.PRIMARY_PHYSICIAN) {
    return (
      section.baseQuestions.reduce(
        (acc: BaseQuestionResource[], baseQuestion: BaseQuestionResource) => {
          if (
            baseQuestion.disclosures &&
            (!isBaseQuestionAnswered(baseQuestion) ||
              questionHasRemainingDisclosures(
                baseQuestion,
                embeddedDisclosures,
              ))
          ) {
            acc.push(baseQuestion);
          } else {
            if (!isBaseQuestionAnswered(baseQuestion)) {
              acc.push(baseQuestion);
            }
          }
          return acc;
        },
        [],
      ).length === 0
    );
  } else if (section.code === CustomSections.PRIMARY_PHYSICIAN) {
    if (primaryPhysician && primaryPhysician.length > 0) {
      return true;
    }
    return false;
  }
  return false;
};
